<template>
  <div class="map-with-popup-container">
    <Loader
      color="blue"
      is-linear
      :is-loading="isLoading"
    />
    <Map
      :items="locations"
      :includes-first-point="!hasMoreLocations"
      :origin="origin"
      :destination="destination"
      :alerts="alerts"
      :fit-to-new-data="fitToNewData"
      @clickedClusteredItems="(items) => locationClicked(items[0])"
      @clickedUnclusteredItem="locationClicked"
    >
      <div slot="popup-content">
        <LastSeenMapPopup
          v-if="isLastSeenPopup"
          :last-seen-time="lastSeenTime"
          :timer-id="timer"
        />
        <MapPopup
          v-else
          :data="popUpData"
          :show-all-data="showAllData"
          :is-wide="isWidePopup"
        />
      </div>
    </Map>
  </div>
</template>
<script>
import Map from '../../atoms/map/map-box';
import Loader from '../../atoms/loader/loader';
import LastSeenMapPopup from '../../atoms/map/last-seen-map-popup';
import MapPopup from '../../atoms/map/map-popup';

export default {
  components: {
    Map,
    LastSeenMapPopup,
    MapPopup,
    Loader,
  },
  props: {
    locations: { type: Array, default: () => [] },
    timer: { type: Number, default: 0 },
    hasMoreLocations: { type: Boolean, default: false },
    origin: { type: Object, default: null },
    destination: { type: Object, default: null },
    alerts: { type: Array, default: () => [] },
    showAllData: { type: Boolean, default: false },
    isWidePopup: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    fitToNewData: { type: Boolean, default: false },
  },
  data() {
    return {
      isLastSeenPopup: false,
      lastSeenTime: null,
      popUpData: null,
    };
  },
  methods: {
    locationClicked(locationProperties) {
      if (locationProperties.type) {
        this.isLastSeenPopup = false;
        this.lastSeenTime = locationProperties.timestamp;
        this.popUpData = locationProperties;
      } else {
        this.isLastSeenPopup = true;
        this.lastSeenTime = locationProperties.timestamp;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.map-with-popup-container {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>
